import './account_form_controller';
import './change_subscription_form_controller';
import '../user/user_form_controller';
import '../upgrade/upgrade_form_controller'
import { DASHBOARD_URL, HUBSPOT_BASE_URL, INTERCOM_BASE_URL, NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:id', {
        template: require('./account.html'),
        controller: 'AccountController'
    });
})
.controller('AccountController', function($scope, $location, $routeParams, $modal, Account, User, AccountChannel, FeatureBillingService, $rootScope, $q, Ticket, ActivationCodes, PandadocService, AccountSubscriptions, Config) {
    let stripeCustomer;
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.loading = true;
    $scope.rtmpAllowed = false;
    $scope.roles = angular.copy(Config.roles)
    $scope.activeTab = {};
    Account.get({ id: $routeParams.id })
    .$promise.then((res) => {
        $scope.updateAccount(res);
        $scope.loading = false;
        $scope.loadTab($location.hash());
    });

    $scope.authURL = PandadocService.authURL

    $scope.updateAccount = (a) => {
      stripeCustomer = a.stripe_customer_handle.length;
      $scope.account = a;
      $scope.rtmpAllowed = (a.feature_flags.indexOf("rtmp") !== -1);
      // Accounts migrated from Sunday Streams have migration IDs prefixed
      // with "ss:"; those from Stream Monkey are prefixed with "sm:".
      $scope.migratedFromSundayStreams = !!a.migration_service_id && a.migration_service_id.indexOf("ss:") === 0;
      $scope.migratedFromStreamMonkey = !!a.migration_service_id && a.migration_service_id.indexOf("sm:") === 0;
      $scope.chatSupport = a.internal_metadata.chat_support;
    }

    $scope.loadBilling = () => {
      $scope.loading = true;
      PandadocService.getUserAccessToken()
      .then((token) => {
          $scope.pandadocToken = token;
        })
      .catch(() => {
          // no token found
      });

      if ($scope.subscriptions || !stripeCustomer) {
          $scope.loading = false;
          return;
      }
      var a = ActivationCodes.queryAccount({ account_id: $routeParams.id });
      var s = AccountSubscriptions.get({ account_id: $routeParams.id });
      $q.all([a.$promise, s.$promise]).then(() => {
          $scope.activationCodes = a;
          $scope.subscriptions = s;
          $scope.featureSummary = FeatureBillingService.featureSummary($scope.account, $scope.subscriptions.features);
      }).finally(() => $scope.loading = false);
    };

    $scope.loadUsers = () => {
      $scope.loading = true;
      if ($scope.users) {
          $scope.loading = false;
          return;
      }
      User.query({ account_id: $routeParams.id, 'filter.include_archived': 'false', l: 100 })
      .$promise.then((res) => {
          $scope.loading = false;
          $scope.users = res;
          $scope.userCount = _.filter(res, user => !user.is_impersonating).length;
      });
    };

    $scope.loadChannels = () => {
      $scope.loading = true;
      if ($scope.channels) {
          $scope.loading = false;
          return;
      }
      AccountChannel.query({ account_id: $routeParams.id, l: 1000 })
      .$promise.then((res) => {
          $scope.loading = false;
          $scope.channels = res;
      });
    };

    $scope.loadTickets = () => {
      $scope.loading = true;
      if ($scope.tickets) {
          $scope.loading = false;
          return;
      }
      // XXX: TODO: the ticket summary doesn't work in admin scope per account ... it just
      // acts on the current logged in user's account only.  Will need to fix API if we want this.
      var p1 = Ticket.queryAccount({account_id: $routeParams.id, type: 'broadcast', s: '-created_at'}).$promise;
      var p2 = Ticket.queryAccount({account_id: $routeParams.id, type: 'channel', s: '-created_at'}).$promise;
      $q.all([p1, p2 /*, p3, p4*/]).then((results) => {
        $scope.tickets = results[0];
        $scope.channelTickets = results[1];
        $scope.loading = false;
      });
    };

    $scope.showTicket = (ticket) => {
    };

    $scope.showTicket = (t) => $location.path(`/broadcasts/${t.broadcast_id}/tickets/${t.id}`);

    $scope.showChannelTicket = (t) => $location.path(`/accounts/${$routeParams.id}/channels/${t.channel_id}/tickets/${t.id}`);

    $scope.boxcastersUrl = () => `/boxcasters?f=account:${encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({ active: true }, _.pick($scope.account, 'id', 'name')))))}`;

    $scope.staticRtmpsUrl = () => `/accounts/${$routeParams.id}/static_rtmps`;

    $scope.broadcastsUrl = () => `${NEW_ADMIN_URL}/broadcasts?f=account:${encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({ active: true }, _.pick($scope.account, 'id', 'name')))))}+only_today`;

    $scope.donationsUrl = () => `/accounts/${$routeParams.id}/donations`;

    $scope.storageBillsUrl = () => `/accounts/${$routeParams.id}/storage_bills`;

    $scope.brandedAppsUrl = () => `/accounts/${$routeParams.id}/branded_apps`;

    $scope.scoreboardAssistsUrl = () => `/scoreboard_assists?f=account:${encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({ active: true }, _.pick($scope.account, 'id', 'name')))))}`;

    $scope.ordersUrl = () => `/orders?f=account:${encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({ active: true }, _.pick($scope.account, 'id', 'name')))))}`;

    $scope.hubspotCompanyUrl = () => `${HUBSPOT_BASE_URL}/company/${$scope.account.hubspot_handle}`;

    $scope.intercomCompanyUrl = () => `${INTERCOM_BASE_URL}/companies/${$scope.account.intercom_company_id}`;

    $scope.showUser = e => window.open(`${$scope.newAdminURL}/accounts/${$routeParams.id}/users/${e.id}`, '_self');

    $scope.requestPayment = function(user) {
        if (confirm(`Please confirm that you want to email ${user.email} to request updated payment information`)) {
            console.log(user);
            return User.update({ account_id: $routeParams.id, id: user.id, request_payment_email: true }, u => alert('Payment request sent!'));
        }
    };

    $scope.showChannel = e => $location.path(`/accounts/${$routeParams.id}/channels/${e.id}`);

    $scope.showHubspotDeal = d => window.open(`${HUBSPOT_BASE_URL}/deal/${d}/`, '_blank')

    $scope.edit = () =>
        $modal.open({
          template: require('./account_form.html'),
          controller: 'AccountFormController',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            mode: () => 'edit'
          }
        }).result.then(a => {
          $scope.updateAccount(a);
        });

    $scope.editUser = () =>
        $modal.open({
          template: require('../user/user_form.html'),
          controller: 'UserFormController',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            account: () => $scope.account
          },
        }).result.then(u => $scope.showUser(u));

    $scope.impersonate = () => {
        Account.impersonate({id: $scope.account.id}, (token) => {
            const { token_type, access_token, scope } = token;
            window.open(`${DASHBOARD_URL}#${jQuery.param({token_type, access_token, scope})}`);
            $rootScope.$broadcast('impersonate_initiated');
        });
    };

    $scope.copyToClipboard = (c) => {
        let selBox = document.createElement('textarea');
        selBox.value = c;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select(); 
        document.execCommand('copy')
        document.body.removeChild(selBox)
    }

    $scope.getLinkedTrialDeals = () => {
        var deals = [];
        $scope.account.external_account_links.forEach((l) => {
            if (l.link_type == 'hubspot:deal' && l.status == 'trial') {
                deals.push(l.external_id);
            }
        });
        return deals;
    }

    $scope.createUpgrade = () => {
        // Check for existing transition deal
        let dealId = null;
        let trialDeals = $scope.getLinkedTrialDeals();
        if ($scope.account.contract == 'trial' && trialDeals.length > 0) {
            dealId = trialDeals[trialDeals.length-1];
        }
        // Default to creating a new deal
        $modal.open({ template: require('../upgrade/upgrade_form.html'), controller: 'UpgradeFormController', size: 'lg', backdrop: 'static', resolve: {isRma:() => false, dealId:() => dealId, pandadocToken:() => $scope.pandadocToken} }).result.then(u => $scope.showHubspotDeal(u.dealid));
    }

    $scope.createRmaUpgrade = () =>
        $modal.open({ template: require('../upgrade/upgrade_form.html'), controller: 'UpgradeFormController', size: 'lg', backdrop: 'static', resolve: {isRma:() => true, dealId:() => null, pandadocToken:() => $scope.pandadocToken} }).result.then(u => $scope.showHubspotDeal(u.dealid));

    $scope.openChangeSubscription = (subscription = null) =>
        $modal.open({
          template: require('./change_subscription_form.html'),
          controller: 'ChangeSubscriptionFormController',
          backdrop: 'static',
          resolve: {
              subscription: () => subscription,
          }
        }).result.then(() => {
            $scope.subscriptions = null;
            $scope.loadBilling();
        });

    $scope.addUrlScheme = (url) => {
        if (/^https?:\/\//i.test(url)) {
            return url;
        } else {
            return 'http://' + url;
        }
    }

    $scope.enableChatSupport = () => {
      if (confirm("Are you sure you want to enable chat support? Once enabled, it cannot be disabled.")) {
        const newInternalMetadata = _.clone($scope.account.internal_metadata);
        newInternalMetadata.chat_support = true;

        $scope.loading = true;
        Account.update({id: $scope.account.id, internal_metadata: newInternalMetadata}).$promise.then((a) => {
          $scope.updateAccount(a);
          $scope.loading = false;
        }).catch((err) => {
          console.error("Error updating account", err);
          alert('Error updating account! Please check the console for more information.');
          $scope.loading = false;
        });
      }
    }

    $scope.loadTab = (tab) => {
      if (tab == '') {
        tab = 'overview';
      }
      $scope.activeTab = {};
      $scope.activeTab[tab] = true;
      switch (tab) {
        case 'billing':
          $scope.loadBilling();
          break;
        case 'users':
          $scope.loadUsers();
          break;
        case 'channels':
          $scope.loadChannels();
          break;
        case 'tickets':
          $scope.loadTickets();
          break;
      }
    }
});



// WEBPACK FOOTER //
// ./views/account/account_controller.js